module.exports = __webpack_public_path__ + "img/電気回路_4_2_3.a459d475.png";